export enum OrderStatus {
  PAID = 'paid',
  PENDING_PAYMENT = 'pending_payment',
  PENDING_SIGNATURE = 'pending_purchaser_signature',
  PARTIALLY_PAID = 'partially_paid',
}
